import {
	DocumentLanguageCode,
	FALLBACK_DOCUMENT_LANGUAGE,
} from './document-language-preference';

export type ReportLanguageCode = DocumentLanguageCode;

export const DEFAULT_REPORT_LANGUAGE_STORAGE_KEY = 'defaultReportLanguage';
export const FALLBACK_REPORT_LANGUAGE: ReportLanguageCode = FALLBACK_DOCUMENT_LANGUAGE;

export function getDefaultReportLanguage(): ReportLanguageCode {
	const stored = localStorage.getItem(DEFAULT_REPORT_LANGUAGE_STORAGE_KEY);
	if (stored === 'ar' || stored === 'en' || stored === 'he') {
		return stored;
	}
	return FALLBACK_REPORT_LANGUAGE;
}

export function setDefaultReportLanguage(code: string): ReportLanguageCode {
	const next = code === 'ar' || code === 'en' || code === 'he' ? code : FALLBACK_REPORT_LANGUAGE;
	localStorage.setItem(DEFAULT_REPORT_LANGUAGE_STORAGE_KEY, next);
	return next;
}
